<div id="Home_section">
  <div class="carousel-container">
    <div class="carousel-slide">
      <img
        [src]="slides[currentSlide].image"
        [alt]="slides[currentSlide].alt"
      />
    </div>

    <button class="carousel-btn prev" (click)="prevSlide()">&#9664;</button>
    <button class="carousel-btn next" (click)="nextSlide()">&#9654;</button>
  </div>

  <div class="home">
    <div class="container">
      <div class="welcome-note">
        <h2>Welcome</h2>
        <p>
          Welcome to the Vendor Portal for Palm Beach Transportation Planning
          Agency. New vendors who have just begun providing goods or services to
          the Agency or who wish to do business with the Agency in the future
          are encouraged to officially register with the Agency by clicking on
          the New Vendor Registration link and completing the registration form.
          Under Vendor Type, Active indicates a vendor that is currently or
          imminently engaging the Agency in business transactions. Prospective,
          on the other hand, indicates that your entity is not currently engaged
          with the Agency but wishes or intends to do business with the Agency
          at some point in the future. Within the Registration Form, you can
          click yes to be included in future bid opportunities. By doing so, any
          competitive written bids prepared by the Organization will be emailed
          to you once publicly issued if the nature and purpose of the
          solicitation relates in any way to your business. Be sure to click on
          Contact to add your contact information including email address within
          the form.
        </p>
        <p>
          If you are an existing vendor currently doing business with Palm Beach
          Transportation Planning Agency, please submit any invoices requiring
          payment by the Agency by clicking on the ‘Vendor Invoice Submission’
          link. If there is a purchase order associated with the goods or
          services you are providing the Agency, please enter your purchase
          order number in the applicable space provided. If you need to submit
          multiple invoices at one time, please do so using the “Multiple
          Invoice Submission” tab. If you are unsure of the purchase order
          number associated with the goods or services you are delivering, you
          can contact Caroline Chavarria, Financial Accounting Specialist, (561)
          725-0814. Be sure to attach your invoice and any other pertinent
          documentation when submitting.
        </p>
        <p>
          We would like to thank you for doing business with Palm Beach
          Transportation Planning Agency, either currently or in the future. By
          entering this pertinent information into the New Vendor Registration
          portal or the Vendor Invoice Submission portal, we will be able to
          communicate new business opportunities to you in a timely manner and
          streamline the invoice submission process so that you can be paid
          quickly and accurately. We look forward to your continued engagement
          with the Agency.
        </p>
      </div>

      <div class="features-box">
        <h2>Our Features</h2>
        <div class="features-row">
          <div class="feature">
            <h3>1. New Vendor Registration</h3>
            <small
              >Note: City will receive your registration. Once approved by the
              city, you will receive an automated email with your vendor ID and
              can proceed to step 2. </small
            ><br />
            <a href="/vendor-registration" class="feature-link">
              <i class="fas fa-user-plus"></i> Register Now
            </a>
          </div>
          <div class="feature">
            <h3>2. Profile Setup</h3>
            <small
              >Once you receive your vendor ID, you can proceed with setting up
              a username and password to submit invoices and monitor invoice and
              Purchase Order history. </small
            ><br />
            <a href="/vendor-sign-up" class="feature-link">
              <i class="fas fa-user-plus"></i> Register Now
            </a>
          </div>
          <div class="feature">
            <h3>3. Vendor Invoice Submission</h3>
            <small
              >Once profile is setup, you can begin submitting invoices through
              the Vendor Invoice Submission page and monitor progress via your
              profile. </small
            ><br />
            <a href="/vendor-invoice" class="feature-link">
              <i class="fas fa-file-invoice-dollar"></i> Submit Invoices
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
